import { takeLatest, call, put, select } from 'redux-saga/effects';
import {
    postLabDepartmentSuccess, postLabDepartmentFailure,
    getLabDepartmentSuccess, getLabDepartmentFailure,
    getLabDepartmentByIdSuccess, getLabDepartmentByIdFailure,
    putLabDepartmentSuccess, putLabDepartmentFailure,
    deleteLabDepartmentSuccess, deleteLabDepartmentFailure,
} from './slice';
import requestHandler from '../../../../utils/requestHandler';
import { logoutRequest } from '../../auth/authSlice';

function* postRequest(action) {
    try {
        const currentBranch = yield select(state => state.branch.currentBranch);
        const requestDetail = {
            method: "POST",
            headers: {
                "Authorization": localStorage.getItem("item"),
                "Content-Type": "application/json",
                "X-Current-Branch": currentBranch.id
            },
            body: JSON.stringify(action.payload)
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/departments`, requestDetail);
        yield put(postLabDepartmentSuccess(response));
    } catch (error) {
        yield put(postLabDepartmentFailure(error?.response?.message || error));
    }
}

function* getRequest(action) {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const { page, limit, searchQuery } = action.payload || { page: 1, limit: null, searchQuery: "" };
        const currentBranch = yield select(state => state.branch.currentBranch);
        const requestDetail = {
            method: "GET",
            headers: {
                "Authorization": authToken,
                "Content-Type": "application/json",
                "X-Current-Branch": currentBranch.id
            }
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/departments?page=${page}&limit=${limit}&searchQuery=${searchQuery}`, requestDetail);
        yield put(getLabDepartmentSuccess(response));
    } catch (error) {
        yield put(getLabDepartmentFailure(error?.response?.message || error));
    }
}

function* getByIdRequest(action) {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const currentBranch = yield select(state => state.branch.currentBranch);
        const requestDetail = {
            method: "GET",
            headers: {
                "Authorization": authToken,
                "Content-Type": "application/json",
                "X-Current-Branch": currentBranch.id
            }
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/departments/${action.payload}`, requestDetail);
        yield put(getLabDepartmentByIdSuccess(response));
    } catch (error) {
        yield put(getLabDepartmentByIdFailure(error?.response?.message || error));
    }
}

function* putRequest(action) {
    try {
        const requestDetail = {
            method: "PUT",
            headers: {
                "Authorization": localStorage.getItem("item"),
                "Content-Type": "application/json"
            },
            body: JSON.stringify(action.payload)
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/departments`, requestDetail);
        yield put(putLabDepartmentSuccess(response));
    } catch (error) {
        yield put(putLabDepartmentFailure(error?.response?.message || error));
    }
}

function* deleteRequest(action) {
    try {
        const requestDetail = {
            method: "DELETE",
            headers: {
                "Authorization": localStorage.getItem("item"),
                "Content-Type": "application/json"
            }
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/departments/${action.payload}`, requestDetail);
        yield put(deleteLabDepartmentSuccess(response));
    } catch (error) {
        yield put(deleteLabDepartmentFailure(error?.response?.message || error));
    }
}

function* saga() {
    yield takeLatest('labDepartment/postLabDepartmentRequest', postRequest);
    yield takeLatest('labDepartment/getLabDepartmentRequest', getRequest);
    yield takeLatest('labDepartment/getLabDepartmentByIdRequest', getByIdRequest);
    yield takeLatest('labDepartment/putLabDepartmentRequest', putRequest);
    yield takeLatest('labDepartment/deleteLabDepartmentRequest', deleteRequest);
}

export default saga;
